/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsStudioPlusVideo = {
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsStudioPlusVideo = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors - find all elements (will be multiple for desktop and mobile)
    const $videoElements = $section.find('[data-video-element]');
    const $playButtons = $section.find('[data-play-button]');
    const $videoTextContainers = $section.find('[data-video-text-container]');
    const $imageElements = $section.find('[data-image-element]');

    // Load video if the media has been added
    if (this.iframe_video || this.mobile_iframe_video || this.html5_video) {
      this.loadVideo($section, $videoElements, $playButtons, $videoTextContainers, $imageElements);
    } else {
      $imageElements.show();
    }

  },
  loadVideo: function($section, $videoElements, $playButtons, $videoTextContainers, $imageElements) {
    console.log('loadVideo called');
    
    // Initialize both desktop and mobile players
    const desktopElement = document.querySelector(`.video-desktop-${this.id}`);
    const mobileElement = document.querySelector(`.video-mobile-${this.id}`);
    
    console.log('Video elements:', { desktopElement, mobileElement });
    
    let desktopPlayer = null;
    let mobilePlayer = null;
    
    // Initialize desktop player if exists
    if (desktopElement) {
      console.log('Initializing desktop player');
      desktopPlayer = new Plyr(`.video-desktop-${this.id}`, {
        controls: videoControls,
        loop: {
          active: this.autoloop
        },
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      desktopPlayer.muted = this.mute;
      desktopPlayer.ratio = this.aspect_ratio;
      console.log('Desktop player initialized', desktopPlayer);
    }
    
    // Initialize mobile player if exists
    if (mobileElement) {
      console.log('Initializing mobile player');
      mobilePlayer = new Plyr(`.video-mobile-${this.id}`, {
        controls: videoControls,
        loop: {
          active: this.autoloop
        },
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      mobilePlayer.muted = this.mute;
      mobilePlayer.ratio = this.mobile_aspect_ratio;
      console.log('Mobile player initialized', mobilePlayer);
    }
    
    // Determine which player is currently active
    const isMobile = window.innerWidth <= 798;
    const player = isMobile ? mobilePlayer : desktopPlayer;
    
    console.log('Active player:', isMobile ? 'mobile' : 'desktop', player);

    // Handle viewport resize - pause video when crossing breakpoint
    let wasMobile = isMobile;
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 798;
      // If we crossed the breakpoint, pause both players
      if (wasMobile !== isNowMobile) {
        if (desktopPlayer && !desktopPlayer.paused) {
          desktopPlayer.pause();
        }
        if (mobilePlayer && !mobilePlayer.paused) {
          mobilePlayer.pause();
        }
        wasMobile = isNowMobile;
      }
    };
    
    // Add resize listener with debouncing
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 100);
    });

    // If autoplay enabled, hide image and text
    if (this.autoplay) {
      if (player) {
        player.autoplay = true;
      }
      $imageElements.hide();
      $videoTextContainers.hide();
      $videoElements.addClass('video-ready').show();
    } else {
      // If autoplay disabled, check if poster image added
      if (this.poster || this.mobile_poster) {
        $videoElements.hide();
        $imageElements.show();
        $videoTextContainers.show();
      } else {
        // If autoplay disabled and no poster image
        $imageElements.hide();
        $videoElements.addClass('video-ready').show();
        $videoTextContainers.show();
      }
    }

    // Helper function to get the active player based on viewport
    const getActivePlayer = () => {
      const isCurrentlyMobile = window.innerWidth <= 798;
      return isCurrentlyMobile ? mobilePlayer : desktopPlayer;
    };

    // If button exists, clicking button will play video
    if (this.button) {
      $playButtons.on('click', () =>  {
        const activePlayer = getActivePlayer();
        console.log('Play button clicked, active player:', activePlayer);
        if (activePlayer) {
          activePlayer.play();
        }
      })
    }

    // Clicking anywhere on video should play the video
    if (!this.button) {
      $videoTextContainers.on('click', () => {
        const activePlayer = getActivePlayer();
        if (activePlayer) {
          activePlayer.play();
        }
      })
    }

    // If on mobile and text is below image, clicking the image wrapper should play the video
    if (!isScreenSizeLarge() && $videoElements.parents('.mobile-text--below-media').length > 0) {
      $imageElements.on('click', () => {
        const activePlayer = getActivePlayer();
        if (activePlayer) {
          activePlayer.play();
        }
      })
    }

    // Setup event handlers for both players
    const setupPlayerEvents = (playerInstance) => {
      if (!playerInstance) return;
      
      const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
      
      // On player ready, hide play icon if play button visible
      playerInstance.on('ready', function(index, player) {
        console.log('Player ready');
        if ($playButtons.length && !isScreenSizeLarge() && $videoElements.parents('.mobile-text--below-media').length > 0) {
          $playIcon.show();
        } else if ($playButtons.length) {
          $playIcon.hide();
        } else {
          $playIcon.show();
        }
      })

      // On play, hide image/text and show video element
      playerInstance.on('play', function(index, player) {
        $videoElements.addClass('video-ready').show();
        $imageElements.hide();
        $videoTextContainers.hide();
      })

      // On player pause, show play icon if play button hidden
      playerInstance.on('pause', function(index, player) {
        if (!$playButtons.length) {
          $playIcon.show();
        }
      })
    };
    
    // Attach event handlers to both players
    setupPlayerEvents(desktopPlayer);
    setupPlayerEvents(mobilePlayer);

  },
  unload: function($section) {
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');

    $playButton.off();
    $videoTextContainer.off();
  }
}

/******/ })()
;

